import { render } from "./AddDocument.vue?vue&type=template&id=91555f64&ts=true"
import script from "./AddDocument.vue?vue&type=script&lang=ts"
export * from "./AddDocument.vue?vue&type=script&lang=ts"

import "./AddDocument.vue?vue&type=style&index=0&id=91555f64&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__